import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {H6Text} from '@buncha/components/core/text';
import React from 'react';
import {styles} from './styles';

interface ExtraItemCountProps {
  count: number;
}

const ExtraItemCount: React.FC<ExtraItemCountProps> = props => {
  const {count} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  return (
    <Box
      style={[
        styles.container,
        {
          backgroundColor: theme?.background.gray[200],
        },
      ]}>
      <H6Text
        style={{
          fontFamily: muliFont[900].normal,
          color: theme?.text.gray[100],
        }}>
        +{count}
      </H6Text>
    </Box>
  );
};

export default React.memo(ExtraItemCount);
